export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acheter"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["pour"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actif"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lien de l’annonce"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID du maker"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Délai"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date de création"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Je paierai"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Je recevrai"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limite de transaction"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tous"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transactions"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID de l’offre"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taux"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner un compte"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hors limite"])}
}